// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setAxisExtremes = createAction('[Fund Chart] Set Axis Extremes', props());
